import { render, staticRenderFns } from "./resetStaffPwd.vue?vue&type=template&id=c36de4c8&scoped=true"
import script from "./resetStaffPwd.vue?vue&type=script&lang=js"
export * from "./resetStaffPwd.vue?vue&type=script&lang=js"
import style0 from "./resetStaffPwd.vue?vue&type=style&index=0&id=c36de4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36de4c8",
  null
  
)

export default component.exports